import React from 'react';
import {
	DeleteIcon,
	EditIcon
} from '../Icons';

const icons = {
	delete: DeleteIcon,
	edit: EditIcon,
}

export interface IconProps {
	name: keyof typeof icons,
	size?: number
	onClick?: () => void;
}

export function Icon(props: IconProps): JSX.Element {
	const { name, size = 16 } = props;
	const Icon = icons[name];


	return (
		<div style={{ width: size, height: size }}>
			<Icon />
		</div>
	);
}